let env = {};

env.baseURL = 'https://api.tihrio-homolog.ares-saude.com.br/api/v1/';
env.normalURL = 'https://api.tihrio-homolog.ares-saude.com.br/';
env.mode = 'homolog';

export default env
